export default "__VITE_ASSET__Gisc$Sub__"